<template>
  <v-app-bar app color="ts_black" dark>
    <router-link to="/">
      <div class="d-flex align-center">
        <v-img
          alt="TechSoup Logo"
          class="shrink mr-2 hidden-md-and-up"
          contain
          :src="require('@/assets/techsoup_logo_orangewhite_icon.png')"
          transition="scale-transition"
          width="40"
        />

        <v-img
          class="shrink mt-1 hidden-sm-and-down"
          alt="TechSoup Name"
          contain
          min-width="100"
          :src="require('@/assets/techsoup_together_logo_orange_white.png')"
          width="120"
        />
      </div>
    </router-link>

    <v-spacer></v-spacer>
    <v-btn
      text
      color="white"
      to="/login"
      outlined
      small
      style="border: 1px solid white; min-width: 120px"
      v-if="!this.$store.getters.user"
    >
      <!-- <v-icon left dark>{{ item.icon }}</v-icon> -->
      Accedi
    </v-btn>
    <v-btn
      color="white"
      to="/signup"
      small
      class="ml-2 ts_black--text"
      style="border: 1px solid white; min-width: 120px;"
      dark
      v-if="!this.$store.getters.user"
    >
      <!-- <v-icon left dark>{{ item.icon }}</v-icon> -->
      Registrati
    </v-btn>

    <v-btn
      text
      color="white"
      v-for="item in menuItems"
      :key="item.title"
      :to="item.link"
      small
      outlined
      class="ml-2"
      style="border: 1px solid white; min-width: 120px;"
    >
      <!-- <v-icon left dark>{{ item.icon }}</v-icon> -->
      {{ item.title }}
    </v-btn>


    <v-btn
      text
      color="secondary"
      v-if="user && user.ua"
      to="/together_admin"
      small
    >
      ADMIN
    </v-btn>

    <UpgradeButton v-if="user && ps && ps.length == 0" class="px-2" />

    <InAppNotifications v-if="user" style="z-index: 99" />
  </v-app-bar>
</template>

<script>
import UpgradeButton from "@/components/UpgradeButton.vue";
import { mapGetters } from "vuex";

export default {
  name: "NavBar",

  components: {
    UpgradeButton,
    InAppNotifications: () => import("@/components/utility/InAppNotifications"), 
  },

  data: () => ({
    //
  }),

  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      user: "user",
      ps: "ps"
    }),
    menuItems() {
      // let menuItems = [
      //   { icon: "mdi-account", title: "Accedi", link: "/login" },
      //   { icon: "mdi-account", title: "Registrati", link: "/signup" },
      // ];
      let menuItems = [];
      if (this.$store.getters.user) {
        menuItems = [
          { icon: "mdi-account", title: "Speakers", link: "/speakers" },
          { icon: "mdi-account", title: "Settings", link: "/settings" },
        ];
      }
      return menuItems;
    },
  },
};
</script>

<style></style>
